import PropTypes from 'prop-types';
import notePropType from './note';

export default PropTypes.arrayOf(notePropType);
